import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Grid } from 'semantic-ui-react';
import { Store } from 'components/Commons';

class BookingForm extends Component {
  render() {
    const { companyStore, onSubmit } = this.props;

    return (
      <Form className="top-form">
        <Grid.Column width={16}>
          <Store notLabel companyStore={companyStore} onChangFunc={onSubmit} />
        </Grid.Column>
      </Form>
    );
  }
}

BookingForm = connect(state => ({
  companyStore: state.commons.companyStore
}))(BookingForm);

export default BookingForm;
